import { urls, documentStatuses, tripDestinations, routeCreatingTypes, transportationMethods, customEventTypes, deliveryPlaces } from '../../../constants.js';
import { getRouteDepartureDate } from '../DocumentHelpers.js';
import { checkRouteForms } from '../../helpers/CheckFunctions.js';
import { eventDispatcher } from '../../../eventDispatcher.js';
import i18next from "../../../i18n.js";

export default {
    updateFields(documentData, context) {
        const { userContext, navigationIndex, location } = context;

        const isTask = location.pathname.startsWith(urls.tasksPage + '/');
        const state = documentData.properties['sx:dfState'];
        const tripDestination = documentData.properties['sx:btBusinessTripDestination'];

        if (tripDestination) {
            if (tripDestination === tripDestinations.abroad) {
                documentData.title = i18next.t('document.businessTripAbroadTitle');
            }
            else {
                documentData.title = i18next.t('document.businessTripUkraineTitle');
            }
        }

        const businessTripUserField = documentData.form.fields.find(f => f.name === 'assoc:sx:btSeconded_added');
        businessTripUserField.disabled = !userContext?.isHead;

        const routeForm = documentData.form.fields.find(f => f.name === 'routeForm');
        routeForm.visible = !(tripDestination === tripDestinations.abroad && (navigationIndex === 2 || navigationIndex === 3) && documentData.properties['sx:btRouteType'] === routeCreatingTypes.auto);
        if (navigationIndex === 2 && documentData.properties['sx:btSameTransportForRoutes'] && !documentData.properties['methodTransportationForAll']) {
            routeForm.visible = false;
        }
        routeForm.showOnlyFirstItem = !documentData.properties['sx:btMultipleRoutes'];

        // Транзитних зупинок два поля з однаковим ім'ям — редаговане на кроці транспорту
        // і показане для читання на кроці проживання, тому видимість ставимо обом
        const transitFormsVisible = tripDestination === tripDestinations.abroad &&
            documentData.properties['sx:btRouteType'] === routeCreatingTypes.custom &&
            documentData.properties['routeForm']?.length > 0 &&
            documentData.properties['routeForm'][0].properties['sx:pbtMethodTransportation'];
        routeForm.fields.filter(f => f.name === 'transitForm').forEach(field => field.visible = transitFormsVisible);

        const goingBackForm = documentData.form.fields.find(f => f.name === 'goingBackForm');
        goingBackForm.showOnlyFirstItem = true;
        goingBackForm.hideTransportLabel = true;
        goingBackForm.hideTransportSelect = documentData.properties['sx:btMultipleRoutes'] && documentData.properties['sx:btSameTransportForRoutes'];
        goingBackForm.visible = tripDestination === tripDestinations.ukraine && documentData.properties['sx:btMultipleRoutes'];
        if (navigationIndex === 2 && documentData.properties['sx:btSameTransportForRoutes'] && !documentData.properties['methodTransportationForAll']) {
            goingBackForm.visible = false;
        }
        goingBackForm.fields.filter(f => f.name === 'transitForm').forEach(field => field.visible = false);

        const methodTransportationField = routeForm.fields.find(f => f.name === 'sx:pbtMethodTransportation');
        const methodTransportationBackField = goingBackForm.fields.find(f => f.name === 'sx:pbtMethodTransportation');
        if (tripDestination === tripDestinations.ukraine && methodTransportationField.values?.data) {
            methodTransportationField.values.data = methodTransportationField.values.data.filter(it => it.value !== transportationMethods.plane);
            methodTransportationBackField.values.data = methodTransportationBackField.values.data.filter(it => it.value !== transportationMethods.plane);
        }

        const backTransportSection = routeForm.fields.find(f => f.name === 'backTransportSection');
        const backMethodTransportationField = backTransportSection.fields.find(f => f.name === 'sx:pbtBackMethodTransportation');
        if (tripDestination === tripDestinations.ukraine && backMethodTransportationField.values?.data) {
            backMethodTransportationField.values.data = backMethodTransportationField.values.data.filter(it => it.value !== transportationMethods.plane);
        }

        const child3YearsField = documentData.form.fields.find(f => f.name === 'sx:btChild3Years');
        child3YearsField.visible = state !== documentStatuses.processing || !isTask;

        const dateStartMainField = documentData.form.fields.find(f => f.name === 'sx:btDateStartMain');
        const dateEndMainField = documentData.form.fields.find(f => f.name === 'sx:btDateEndMain');
        const routeFormMain = documentData.form.fields.find(f => f.name === 'routeFormMain');
        dateStartMainField.visible = dateEndMainField.visible = routeFormMain.visible = state === documentStatuses.processing && isTask;


        const insuranceInfoField = documentData.form.fields.find(f => f.name === 'insuranceInfo');
        const healthInsuranceField = documentData.form.fields.find(f => f.name === 'sx:btHealthInsurance');

        healthInsuranceField.visible = tripDestination === tripDestinations.abroad;
        insuranceInfoField.visible = healthInsuranceField.visible && documentData.properties['sx:btHealthInsurance'];

        const profileUpdateField = documentData.form.fields.find(f => f.name === 'profileUpdate');
        profileUpdateField.visible = (state !== documentStatuses.processing || !isTask) && this.isProfileUpdateFieldVisible(documentData, userContext);
        if (!profileUpdateField.visible) documentData.properties['profileUpdate'] = false;

        const deliveryPlaceField = documentData.form.fields.find(f => f.name === 'sx:btDeliveryPlace');
        const routeTypeField = documentData.form.fields.find(f => f.name === 'sx:btRouteType');

        deliveryPlaceField.visible = routeTypeField.visible = (state !== documentStatuses.processing || !isTask) && tripDestination === tripDestinations.abroad;

        const urgentRequestField = documentData.form.fields.find(f => f.name === 'sx:btUrgentRequest');
        urgentRequestField.visible = userContext.isHead;

        const transportInfoBoxField = documentData.form.fields.find(f => f.name === 'transportInfoBox');
        const transportPreferencesField = documentData.form.fields.find(f => f.name === 'sx:btTransportationPreferences');
        const residenceInfoBoxField = documentData.form.fields.find(f => f.name === 'residenceInfoBox');
        const residencePreferencesField = documentData.form.fields.find(f => f.name === 'sx:btAccommodationPreferences');
        transportInfoBoxField.visible = transportPreferencesField.visible = residenceInfoBoxField.visible = residencePreferencesField.visible =
            tripDestination === tripDestinations.abroad && documentData.properties['sx:btRouteType'] === routeCreatingTypes.auto;

        this.updateRouteFormFields(documentData, 'routeForm');
        this.updateRouteFormFields(documentData, 'goingBackForm');
        if (state === documentStatuses.processing && isTask) this.updateRouteFormFields(documentData, 'routeFormMain');

        const autoOwnerSectionForAll = documentData.form.fields.find(f => f.name === 'autoOwnerSection_forAll');
        const corporateCarInfoForAll = documentData.form.fields.find(f => f.name === 'corporateCarInfo_forAll');
        const carInfoFormForAll = documentData.form.fields.find(f => f.name === 'carInfoForm_forAll');
        autoOwnerSectionForAll.visible = documentData.properties['sx:btMultipleRoutes'] && documentData.properties['sx:btSameTransportForRoutes'] && documentData.properties['methodTransportationForAll'] === transportationMethods.autoColleagues;
        corporateCarInfoForAll.visible = documentData.properties['sx:btMultipleRoutes'] && documentData.properties['sx:btSameTransportForRoutes'] && documentData.properties['methodTransportationForAll'] === transportationMethods.corporateCar;
        carInfoFormForAll.visible = documentData.properties['sx:btMultipleRoutes'] && documentData.properties['sx:btSameTransportForRoutes'] && (documentData.properties['methodTransportationForAll'] === transportationMethods.ownCar || documentData.properties['methodTransportationForAll'] === transportationMethods.carRental);

        if (documentData.properties['methodTransportationForAll'] === transportationMethods.ownCar) {
            carInfoFormForAll.userNodeRef = documentData.properties['assoc:sx:btSeconded_added'];
            carInfoFormForAll.userName = documentData.properties['sx:btSeconded'];
        }
        else {
            carInfoFormForAll.userNodeRef = '';
            carInfoFormForAll.userName = '';
        }

        const ownCarInfoForAll = carInfoFormForAll.fields.find(f => f.name === 'ownCarInfo');
        const greenCardField = ownCarInfoForAll.fields.find(f => f.name === 'sx:ciGreenCard');
        greenCardField.visible = false;

        const ownCarAttachmentsField = carInfoFormForAll.fields.find(f => f.name === 'ownCarAttachments');
        ownCarAttachmentsField.visible = documentData.properties['methodTransportationForAll'] === transportationMethods.ownCar;

        const rentalCarBillAttachmentsField = carInfoFormForAll.fields.find(f => f.name === 'rentalCarBillAttachments');
        rentalCarBillAttachmentsField.visible = documentData.properties['methodTransportationForAll'] === transportationMethods.carRental;

        const rentalCarActAttachmentsField = carInfoFormForAll.fields.find(f => f.name === 'rentalCarActAttachments');
        rentalCarActAttachmentsField.visible = documentData.properties['methodTransportationForAll'] === transportationMethods.carRental;

        routeForm.multiple = documentData.properties['sx:btMultipleRoutes'];
        routeForm.disabled = navigationIndex != 1 || routeForm.showOnlyFirstItem;
        routeForm.hideItemLabel = !documentData.properties['sx:btMultipleRoutes'];
        routeForm.hideTransportLabel = documentData.properties['sx:btMultipleRoutes'];
        routeForm.hideTransportSelect = documentData.properties['sx:btMultipleRoutes'] && documentData.properties['sx:btSameTransportForRoutes'];

        const sameTransportForAllField = documentData.form.fields.find(f => f.name === 'sx:btSameTransportForRoutes');
        const sameTransportForAllTextField = documentData.form.fields.find(f => f.name === 'sameTransportForAllText');

        sameTransportForAllField.visible = documentData.properties['sx:btMultipleRoutes'];
        sameTransportForAllTextField.visible = documentData.properties['sx:btMultipleRoutes'] && !documentData.properties['sx:btSameTransportForRoutes'];

        const methodTransportationForAllField = documentData.form.fields.find(f => f.name === 'methodTransportationForAll');
        methodTransportationForAllField.visible = sameTransportForAllField.visible && documentData.properties['sx:btSameTransportForRoutes'];

        if (tripDestination === tripDestinations.ukraine && methodTransportationForAllField.values?.data) {
            methodTransportationForAllField.values.data = methodTransportationForAllField.values.data.filter(it => it.value !== transportationMethods.plane);
        }
    },

    isProfileUpdateFieldVisible(documentData, userContext) {
        let isCurrentUser = documentData.properties['assoc:sx:btSeconded_added'] === userContext?.nodeRef;
        if (isCurrentUser) {
            const child3Years = userContext?.childUnder3Years ?? false;
            if (documentData.properties['sx:btChild3Years'] !== null && documentData.properties['sx:btChild3Years'] !== undefined && documentData.properties['sx:btChild3Years'] !== child3Years) {
                return true;
            }
        }
        return false;
    },

    updateRouteFormFields(documentData, fieldName) {
        const tripDestination = documentData.properties['sx:btBusinessTripDestination'];

        const routeForm = documentData.form.fields.find(f => f.name === fieldName);
        const placeInfo = routeForm.fields.find(f => f.name === 'placeInfo');

        const countryField = placeInfo.fields.find(f => f.name === 'sx:pbtCountryBusinessTrip');
        const cityField = placeInfo.fields.find(f => f.name === 'sx:pbtCity');
        const localityField = placeInfo.fields.find(f => f.name === 'sx:pbtLocality');
        const regionField = placeInfo.fields.find(f => f.name === 'sx:pbtRegion');
        const tripGoalField = placeInfo.fields.find(f => f.name === 'sx:pbtTripGoal');
        const internalPurposeField = placeInfo.fields.find(f => f.name === 'sx:pbtTripGoalForeign');

        const travelForm = routeForm.fields.find(f => f.name === 'travelForm');
        const placeStartEndDateField = travelForm.fields.find(f => f.name === 'placeStartEndDate');
        const placeStartEndDateMultipleField = travelForm.fields.find(f => f.name === 'placeStartEndDateMultiple');
        placeStartEndDateField.visible = !documentData.properties['sx:btMultipleRoutes'] || fieldName === 'goingBackForm';
        placeStartEndDateMultipleField.visible = documentData.properties['sx:btMultipleRoutes'] && fieldName !== 'goingBackForm';
        placeStartEndDateMultipleField.settings.hideEndDate = true;
        if (fieldName === 'goingBackForm') {
            placeStartEndDateField.settings.startLabel = placeStartEndDateField.settings.endLabel;
        }

        if (fieldName === 'goingBackForm') {
            travelForm.label = i18next.t('document.backRoute');

            const travelPreferencesField = travelForm.fields.find(f => f.name === 'sx:tfPreferredDepartureTime');
            travelPreferencesField.placeholder = i18next.t('document.backPreferencesPlaceholder');

            const routeInfoField = travelForm.fields.find(f => f.name === 'routeInfo');
            routeInfoField.visible = false;
        }

        countryField.visible = cityField.visible = tripDestination === tripDestinations.abroad;
        regionField.visible = localityField.visible = tripDestination === tripDestinations.ukraine;
        tripGoalField.visible = tripDestination === tripDestinations.ukraine;
        internalPurposeField.visible = tripDestination === tripDestinations.abroad;

        const carInfoForm = routeForm.fields.find(f => f.name === 'carInfoForm');
        const greenCardField = carInfoForm.fields.find(f => f.name === 'sx:ciGreenCard');
        greenCardField.visible = tripDestination === tripDestinations.abroad;

        const ownCarInfo = carInfoForm.fields.find(f => f.name === 'ownCarInfo');
        const greenCardOwnInfoField = ownCarInfo.fields.find(f => f.name === 'sx:ciGreenCard');
        greenCardOwnInfoField.visible = tripDestination === tripDestinations.abroad;

        const routeBackInfoSection = routeForm.fields.find(f => f.name === 'routeBackInfoSection');
        const carInfoBackForm = routeBackInfoSection.fields.find(f => f.name === 'carInfoBackForm');
        const ownCarInfoBack = carInfoBackForm.fields.find(f => f.name === 'ownCarInfo');
        const greenCardOwnInfoBackField = ownCarInfoBack.fields.find(f => f.name === 'sx:ciGreenCard');
        greenCardOwnInfoBackField.visible = tripDestination === tripDestinations.abroad;

        const sameTransportBackField = routeForm.fields.find(f => f.name === 'sx:pbtSameTransportBack');
        sameTransportBackField.visible = !documentData.properties['sx:btMultipleRoutes'];
        routeBackInfoSection.visible = !documentData.properties['sx:btMultipleRoutes'];

        // межі, у яких взагалі можна вибирати дати маршрутів — це дати відрядження
        routeForm.minDate = documentData.properties['sx:btDateStart'];
        routeForm.maxDate = documentData.properties['sx:btDateEnd'];
        routeForm.userNodeRef = documentData.properties['assoc:sx:btSeconded_added'];
        routeForm.tripDestination = tripDestination;
        // повернення не може бути раніше за виїзд останнього маршруту
        if (fieldName === 'goingBackForm') {
            const lastDepartureDate = getRouteDepartureDate(documentData.properties['routeForm']?.at(-1));
            if (lastDepartureDate) {
                routeForm.minDate = lastDepartureDate;
            }
        }
        if (fieldName === 'routeForm') {
            routeForm.goingBackForm = documentData.properties['goingBackForm'];
        }
        const autoOwnerSection = routeForm.fields.find(f => f.name === 'autoOwnerSection');
        const corporateCarInfoSection = routeForm.fields.find(f => f.name === 'corporateCarInfo');
        autoOwnerSection.visible = corporateCarInfoSection.visible = carInfoForm.visible = !documentData.properties['sx:btSameTransportForRoutes'] || !documentData.properties['sx:btMultipleRoutes'];
    },

    checkInputPage(documentData, context) {
        let result = true;
        let errorElementName = '';
        let errorElementId = '';
        let nIndex = 0;

        const { navigationIndex } = context;

        if (navigationIndex > 0) {
            if (documentData.properties["sx:btMainPlace"] && !documentData.properties['sx:btCityReturn']) {
                result = false;
                nIndex = 1;
                errorElementName = "startingPoint";
            }
            if (!documentData.properties["sx:btMainPlace"] && !documentData.properties['sx:btReasonWorkPlace']) {
                result = false;
                nIndex = 1;
                errorElementName = "startingPoint";
            }
            if (result && !documentData.properties["sx:btMainPlace"] && !documentData.properties["sx:btReason"]) {
                result = false;
                nIndex = 1;
                errorElementName = "startingPoint";
            }
            if (result && !documentData.properties["sx:btDateStart"]) {
                result = false;
                nIndex = 1;
                errorElementName = "startEndDate";
            }
            if (result && !documentData.properties["sx:btDateEnd"]) {
                result = false;
                nIndex = 1;
                errorElementName = "startEndDate";
            }
            if (result) {
                if (!documentData.properties["assoc:sx:btSeconded_added"]) {
                    result = false;
                    nIndex = 1;
                    errorElementName = "assoc:sx:btSeconded_added";
                }
            }
            if (result) {
                let formCheckResult = checkRouteForms(documentData, 'routeForm', 1);
                if (!formCheckResult.result) {
                    result = false;
                    nIndex = 1;
                    errorElementName = formCheckResult.errorElementName;

                    eventDispatcher.invokeEvent(customEventTypes.onSubformError, {
                        subformName: 'routeForm',
                        index: formCheckResult.formIndex,
                        subform: formCheckResult.subform
                    });
                }
                if (result && documentData.properties['sx:btBusinessTripDestination'] === tripDestinations.abroad) {
                    if (documentData.properties["sx:btHealthInsurance"]) {
                        if (result && !documentData.properties["sx:btRegionRegistration"]) {
                            result = false;
                            nIndex = 1;
                            errorElementName = "sx:btRegionRegistration";
                        }
                        if (result && !documentData.properties["sx:btPlaceResidence"]) {
                            result = false;
                            nIndex = 1;
                            errorElementName = "sx:btPlaceResidence";
                        }
                        if (result && !documentData.properties["sx:btStreetResidence"]) {
                            result = false;
                            nIndex = 1;
                            errorElementName = "sx:btStreetResidence";
                        }
                        if (result && !documentData.properties["sx:btHouseRegistration"]) {
                            result = false;
                            nIndex = 1;
                            errorElementName = "sx:btHouseRegistration";
                        }
                        // для страхування обов'язкове фото паспорта
                        if (result && !(documentData.properties["passportAttachments"]?.length > 0)) {
                            result = false;
                            nIndex = 1;
                            errorElementName = "passportAttachments";
                        }
                    }
                    if (result && !documentData.properties["sx:btDeliveryPlace"]) {
                        result = false;
                        nIndex = 1;
                        errorElementName = "sx:btDeliveryPlace";
                    }
                }
                if (result && navigationIndex > 1 && documentData.properties["sx:btSameTransportForRoutes"]) {
                    if (!documentData.properties["methodTransportationForAll"]) {
                        result = false;
                        nIndex = 2;
                        errorElementName = "methodTransportationForAll";
                    }
                }
                if (result && navigationIndex > 1) {
                    formCheckResult = checkRouteForms(documentData, 'routeForm', 2);
                    if (formCheckResult.result && documentData.properties['sx:btMultipleRoutes']) {
                        formCheckResult = checkRouteForms(documentData, 'goingBackForm', 2);
                    }
                    if (!formCheckResult.result) {
                        result = false;
                        nIndex = 2;
                        errorElementName = formCheckResult.errorElementName;

                        if (errorElementName === 'routeForm---0---transitForm---0---sx:pbtCity' && navigationIndex === 3) {
                            nIndex = 3;
                        }

                        eventDispatcher.invokeEvent(customEventTypes.onSubformError, {
                            subformName: 'routeForm',
                            index: formCheckResult.formIndex,
                            subform: formCheckResult.subform
                        });
                    }
                }
                if (result && navigationIndex > 1 && documentData.properties["sx:btSameTransportForRoutes"]) {
                    if (!documentData.properties["methodTransportationForAll"]) {
                        result = false;
                        nIndex = 2;
                        errorElementName = "methodTransportationForAll";
                    }
                    if (result && documentData.properties["methodTransportationForAll"] === transportationMethods.autoColleagues && !documentData.properties["assoc:sx:pbtColleague_added_forAll"]) {
                        result = false;
                        nIndex = 2;
                        errorElementName = "assoc:sx:pbtColleague_added_forAll";
                    }
                    if (result && documentData.properties["methodTransportationForAll"] === transportationMethods.corporateCar) {
                        if (!documentData.properties["sx:ciBrandCar_forAll"]) {
                            result = false;
                            nIndex = 2;
                            errorElementName = "sx:ciBrandCar_forAll";
                        }
                        if (result && !documentData.properties["sx:ciModelCar_forAll"]) {
                            result = false;
                            nIndex = 2;
                            errorElementName = "sx:ciModelCar_forAll";
                        }
                        if (result && !documentData.properties["sx:ciRegNumerInfo_forAll"]) {
                            result = false;
                            nIndex = 2;
                            errorElementName = "sx:ciRegNumerInfo_forAll";
                        }
                    }
                    if (result && (documentData.properties["methodTransportationForAll"] === transportationMethods.ownCar || documentData.properties["methodTransportationForAll"] === transportationMethods.carRental)) {
                        const carInfoForm = documentData.properties['carInfoForm_forAll'][0];
                        if (result && !carInfoForm.properties['sx:ciBrandCar']) {
                            result = false;
                            nIndex = 2;
                            errorElementName = "carInfoForm_forAll---0---sx:ciBrandCar";
                        }
                        if (result && !carInfoForm.properties['sx:ciRegNumerInfo']) {
                            result = false;
                            nIndex = 2;
                            errorElementName = "carInfoForm_forAll---0---sx:ciRegNumerInfo";
                        }
                        if (result && !carInfoForm.properties['sx:ciReleaseYear']) {
                            result = false;
                            nIndex = 2;
                            errorElementName = "carInfoForm_forAll---0---sx:ciReleaseYear";
                        }
                        if (result && !carInfoForm.properties['sx:ciEngineType']) {
                            result = false;
                            nIndex = 2;
                            errorElementName = "carInfoForm_forAll---0---sx:ciEngineType";
                        }
                        if (result && !carInfoForm.properties[`sx:ciFuelType_${carInfoForm.properties['sx:ciEngineType']}`]) {
                            result = false;
                            nIndex = 2;
                            errorElementName = `carInfoForm_forAll---0---sx:ciFuelType_${carInfoForm.properties['sx:ciEngineType']}`;
                        }
                        if (result && !carInfoForm.properties['sx:ciEngineDisplacement']) {
                            result = false;
                            nIndex = 2;
                            errorElementName = "carInfoForm_forAll---0---sx:ciEngineDisplacement";
                        }
                        if (result && !carInfoForm.properties['sx:ciCarColor']) {
                            result = false;
                            nIndex = 2;
                            errorElementName = "carInfoForm_forAll---0---sx:ciCarColor";
                        }
                        if (result && documentData.properties["methodTransportationForAll"] === transportationMethods.ownCar) {
                            if (!(carInfoForm.properties["ownCarAttachments"]?.length > 0)) {
                                result = false;
                                nIndex = 2;
                                errorElementName = `carInfoForm_forAll---0---ownCarAttachments`;
                            }
                        }
                        if (result && documentData.properties["methodTransportationForAll"] === transportationMethods.carRental) {
                            if (!(carInfoForm.properties["rentalCarBillAttachments"]?.length > 0)) {
                                result = false;
                                nIndex = 2;
                                errorElementName = `carInfoForm_forAll---0---rentalCarBillAttachments`;
                            }
                            if (result && !(carInfoForm.properties["rentalCarActAttachments"]?.length > 0)) {
                                result = false;
                                nIndex = 2;
                                errorElementName = `carInfoForm_forAll---0---rentalCarActAttachments`;
                            }
                        }
                    }
                }
                if (result && navigationIndex > 2) {
                    formCheckResult = checkRouteForms(documentData, 'routeForm', 3);
                    if (!formCheckResult.result) {
                        result = false;
                        nIndex = 3;
                        errorElementName = formCheckResult.errorElementName;

                        eventDispatcher.invokeEvent(customEventTypes.onSubformError, {
                            subformName: 'routeForm',
                            index: formCheckResult.formIndex,
                            subform: formCheckResult.subform
                        });
                    }
                }
            }
            if (result && documentData.properties["sx:btBusinessTripDestination"] === tripDestinations.abroad) {
                switch (documentData.properties["sx:btDeliveryPlace"]) {
                    case deliveryPlaces.np:
                        if (!documentData.properties["sx:btAddress"]) {
                            result = false;
                            nIndex = 0;
                            errorElementName = "sx:btAddress";
                        }
                        if (result && !documentData.properties["sx:btBranchNumber"]) {
                            result = false;
                            nIndex = 0;
                            errorElementName = "sx:btBranchNumber";
                        }
                        if (result && !documentData.properties["sx:btNumber"]) {
                            result = false;
                            nIndex = 0;
                            errorElementName = "sx:btNumber";
                        }
                        break;
                    case deliveryPlaces.ukrPost:
                        if (!documentData.properties["sx:btIndex"]) {
                            result = false;
                            nIndex = 0;
                            errorElementName = "sx:btIndex";
                        }
                        if (result && !documentData.properties["sx:btNumberU"]) {
                            result = false;
                            nIndex = 0;
                            errorElementName = "sx:btNumberU";
                        }
                        break;
                    case deliveryPlaces.tt:
                        if (!documentData.properties["sx:btPointLocation"]) {
                            result = false;
                            nIndex = 0;
                            errorElementName = "sx:btPointLocation";
                        }
                        break;
                    default:
                        break;
                }
            }
        }

        return {
            result,
            errorElementName,
            errorElementId,
            nIndex
        };
    }
}